<template>
  <DefaultPageContainer error-page>
    <section
      class="section section--linear-gradient"
      :class="{'hidden': getErrorCode() < 500 }"
    >
      <div class="flex flex-col items-center text-center gap-2 pt-4 pb-12">
        <div class="pb-8">
          <span class="text-8xl font-extrabold text-white/80" v-html="getHeadingMessage()"></span>
        </div>
        <h3 class="text-5xl font-black">
          {{ getErrorCode() }}
        </h3>
        <div class="text-lg font-semibold" v-html="getHeadingTitle()"></div>
        <div class="md:w-1/2 text-sm">
          <p class="text-white/80" v-html="getSubheadingMessage()" />
          <button
            @click="handleError"
            class="underline font-semibold inline"
          >
            {{ $t('errors.go_to_homepage') }}
          </button>
        </div>
      </div>
    </section>
    <section
      class="section section--linear-gradient"
      :class="{'hidden': getErrorCode() >= 500 }"
    >
      <div class="flex flex-col items-center text-center gap-2 pt-4 pb-12">
        <div class="pb-8">
          <span class="text-8xl font-extrabold text-white/80" v-html="getHeadingMessage()"></span>
        </div>
        <h3 class="text-5xl font-black">
          {{ getErrorCode() }}
        </h3>
        <div class="text-lg font-semibold" v-html="getHeadingTitle()"></div>
        <div class="md:w-1/2 text-sm">
          <p class="text-white/80" v-html="getSubheadingMessage()" />
          <button
            @click="handleError"
            class="underline font-semibold inline"
          >
            {{ $t('errors.go_to_homepage') }}
          </button>
        </div>
      </div>
    </section>
  </DefaultPageContainer>
</template>

<script setup lang="ts">
import type {NuxtError} from '#app'
import { useI18n } from "vue-i18n"

const {t} = useI18n()
const logger = useFrontendLogger()
const config = useRuntimeConfig()

const props = defineProps({
  error: Object as () => NuxtError
})

const getErrorCode = () => {
  return props.error?.statusCode || 500
}

const getHeadingTitle = () => {
  switch (getErrorCode()) {
    case 401:
      return t('errors.error_401_header_title')
    case 404:
    case 410:
      return t('errors.error_404_header_title')
    default:
      return t('errors.error_500_header_title')
  }
}

const getHeadingMessage = () => {
  switch (getErrorCode()) {
    case 401:
      return t('errors.error_401_heading')
    case 404:
    case 410:
      return t('errors.error_404_heading')
    default:
      return t('errors.error_500_heading')
  }
}

const getSubheadingMessage = () => {
  switch (getErrorCode()) {
    case 401:
      return t('errors.error_401_subheading')
    case 404:
    case 410:
      return t('errors.error_404_subheading')
    default:
      return t('errors.error_500_subheading')
  }
}

const handleError = () => clearError({redirect: "/"})

const logError = () => {
  switch (getErrorCode()) {
    case 401:
      logger.error(`Nuxt error page: Login failed (code: ${getErrorCode()})`, props.error)
      return
    case 404:
    case 410:
      logger.error(`Nuxt error page: Page not found (code: ${getErrorCode()})`, props.error)
      return
    default:
      logger.error(`Nuxt error page: Server error (code: ${getErrorCode()})`, props.error)
      return
  }
}

logError()
</script>
